import SvgIcon from "./SvgIcon";

export default function HikeIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M8.35 20.27l.25-.25a.815.815 0 011.14 0l.26.25a3.208 3.208 0 002.28.95h3.02l-.98-1.35h-2.04c-.499 0-.977-.198-1.33-.55l-.25-.25a2.166 2.166 0 00-2.353-.467c-.26.108-.498.267-.697.467l-.25.24a1.876 1.876 0 01-1.34.56h-.48l-.97 1.35h1.45a3.273 3.273 0 002.29-.95z"
        fill={color}
      />
      <path
        d="M2.94 21.21h.01l.97-1.34h-.81a1.494 1.494 0 01-1.49-1.49c0-.572.04-1.144.12-1.71h10.23v-.05l-.93-1.29H1.99l.45-2.27a2.695 2.695 0 011.32-1.83l6.35-3.55V6.14s-7.07 3.95-7.1 3.97l.19-.98A2.4 2.4 0 014.39 7.5l3.3-1.83.59-1.16a.988.988 0 01.89-.55 2.123 2.123 0 012.02 1.47l.03.09c.054.185.081.377.08.57v6.33l1.35.71v-2.39c.102.081.213.152.33.21l1.33.71v2.36l1.35.71v-2.36l1.67.89v2.36l1.34.71v-2.36l1.31.7h1.6a.755.755 0 01.75.75 4.453 4.453 0 01-4.45 4.45h-1.9l.95 1.31-.06.04h1.01a5.8 5.8 0 005.79-5.8 2.1 2.1 0 00-2.09-2.09h-1.26l-6.7-3.57a1.83 1.83 0 01-.97-1.62V6.09a3.483 3.483 0 00-3.48-3.48A2.32 2.32 0 007.08 3.9l-.4.79-2.95 1.63a3.71 3.71 0 00-1.85 2.55L.51 15.89c-.16.82-.24 1.654-.24 2.49a2.837 2.837 0 002.67 2.83z"
        fill={color}
      />
    </SvgIcon>
  )
}
